<template>
  <Layout>
    <a slot="toolbar" class="btn btn-primary" v-b-modal.추가 v-text="$t('사용자 추가')" />

    <TableView :keep-page="keepPage" slot="content" @action="action" @nextList="nextList" :actions="actions"
    :action-filter="(item, action) => !(
          ((action == '잠금' || '수정' || '오류횟수 초기화' || '비밀번호 초기화') && item.statusCd == 'D') 
          ||(action == '잠금' && item.statusCd == 'L') 
          ||(action == '잠금해제' && (item.statusCd == 'A' || item.statusCd == 'U' || item.statusCd == 'D'))
        )"
      :columns="columns" :data="sel" :filters="filter" :list="list" :server-total="total" minWidth="1015px">
      <div class="d-flex align-items-center position-relative me-3">
        <b-icon icon="search" />
        <input @change="listParams.searchKeyword = $event.target.value" class="form-control form-control-solid w-250px ps-11"
          :placeholder="$t('사용자명, 아이디, 이메일, 연락처')" :title="$t('사용자명, 아이디, 이메일, 연락처')">
      </div>
      <b-button variant="light-primary" v-b-modal.상세>
        <b-icon icon="filter" /> {{ $t('상세') }}
      </b-button>
    </TableView>

    <ModalForm id="view" :title="$t('사용자')" :data="sel" :spec="columns" />

    <ModalForm @action="addAction" id="추가" ref="addUser" :title="$t('사용자 추가')" :data="sel" :spec="columns" @show="modalAddUser()" no-close-on-ok>
      <b-form-group label="관리자 전용" label-cols='5'>
        <div class="form-check form-switch form-check-custom form-check-solid"><!-- 관리자 전용 스위치 -->
          <b-form-checkbox switch v-model="adminOnly" />
        </div>
      </b-form-group>
      <b-form-group :label="$t('아이디')" label-class="required" label-align="end" label-cols="5">
        <b-input-group>
          <b-form-input v-model="userIdInput" maxlength="30"/>
        </b-input-group>
      </b-form-group>
      <b-form-group :label="$t('비밀번호')" label-align="end" label-cols="5" class="me-4">
        <b-form-input style="color:green" readonly="readonly" :value="'※ ' + $t('자동생성')" />
      </b-form-group>
    </ModalForm>

    <ModalForm @action="editAction" id="수정" ref="editUser" :title="$t('사용자 수정')" :data="sel" :spec="columns" @show="modalEditUser()" no-close-on-ok >
      <b-form-group label="관리자 전용" label-cols='5'>
        <div class="form-check form-switch form-check-custom form-check-solid"><!-- 관리자 전용 스위치 -->
          <b-form-checkbox switch v-model="adminOnly" />
        </div>
      </b-form-group>
      <b-form-group :label="$t('아이디')" label-class="required" label-align="end" label-cols="5">
        <b-input-group>
          <b-form-input v-model="userIdInputEdit" maxlength="30" readonly/>
        </b-input-group>
      </b-form-group>
    </ModalForm>
      
    <!-- @action="detailSearch" -->
    <ModalForm id="상세" @cancel="detailSearch({})" modal-class="compact" title="$t('발효일')" ok-title="검색" cancel-title="초기화"
      :data="detail" close-on-backdrop ref="detailSearch" @action="detailSearch"
      :spec="[
        { label: '발효일', form: 1, type: 'date-between', key: 'effectDt' }, 
        { label: '로그인 실패 횟수 초과', form: 2, key: 'pwdErrCnt', slot: 'detailSlot' }]">
      <template slot="detailSlot">
        <b-form-group label-cols='5'>
          <div class="form-check form-switch form-check-custom form-check-solid">
            <b-form-checkbox switch v-model="detail.pwdErrOver" />
          </div>
        </b-form-group>
      </template>
    </ModalForm>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import ModalForm from "@/components/ModalForm.vue";
import ItemView from "@/components/ItemView.vue";
const required = true;

export default {
  components: { Layout, TableView, ModalForm, ItemView },
  data: () => ({
    keepPage: false, sel: {}, list: [], total: 0,
    userIdInput: '', userIdInputEdit: '',
    pwdErrOver: false,    
    adminOnly: false,
    ifRed: '',
    /** [columns 스펙]
     * form: view, 추가, 수정 팝업에서 출력순서
     * prepend, append: 추가, 수정 팝업에서 단위 등의 입력폼 좌/우측에 표시될 내용
     * hide: td(테이블) 및 엑션 팝업에서 숨김
     * readonly: 추가, 수정 팝업에서 읽기전용
     * default: 추가, 수정 팝업에서 초기값
     * type: 추가, 수정 팝업에서 input type
     * options: 추가, 수정 팝업에서 select 로 표시될 option 항목
     * required: 필수값 여부
     * sendMaper: 전송시에만 값을 변경할 경우의 필터함수
     * vaildate: 전송전 입력항목을 체크하여 전송불가한 사유를 반환
    */
    columns: [
      { form: 1, label: '상태', key: 'statusNm', hide: ['추가', '수정'], style: { textAlign: 'center', minWidth: '40px' }, renderer: item => `<b class="badge badge-light-${item.statusClass}">${item.statusNm}</b>` },
      { form: 2, label: '관리자 전용', key: 'adminOnly', hide: ['td', 'view', '추가', '수정'], style: { textAlign: 'center', minWidth: '40px' } },
      { form: 3, label: '관리자 전용', key: 'adminOnlyNm', hide: ['td', '추가', '수정'], style: { textAlign: 'center', minWidth: '40px' } },
      { form: 4, label: '사용자', hide: ['view', '추가', '수정'], style: { textAlign: 'center', minWidth: '80px' }, renderer: (item, scope) => `${item.userNm} (${item.userIdText}) ${item.adminOnly=="Y" ? scope.$parent.$parent.admIcon() : ''}` },
      { form: 5, label: '아이디', key: 'userIdText', hide: ['td', '추가', '수정'], readonly: ['수정'], style: { textAlign: 'center', minWidth: '50px' }, required, renderer: item => item.userIdText, maxlength: 30 },
      { form: 6, label: '이메일', key: 'email', readonly: ['수정'], type: 'email', style: { textAlign: 'center', minWidth: '70px' }, maxlength: 100, required },
      { form: 7, label: '사용자명', key: 'userNm', hide: ['td'], style: { textAlign: 'center', minWidth: '60px' }, maxlength: 30, required },
      { form: 8, label: '사용자영문명', key: 'userNmEn', hide: ['td'], style: { textAlign: 'center', minWidth: '60px' }, maxlength: 30 },
      { form: 9, label: '연락처', key: 'phone', type: 'tel', style: { textAlign: 'center', minWidth: '60px' } },
      { form: 10, label: '권한', key: 'roleNm', hide: ['추가', '수정'], style: { textAlign: 'center', minWidth: '60px' } },
      { form: 11, label: '권한', key: 'roleId', hide: ['td', 'view'], style: { textAlign: 'center', minWidth: '60px' } },
      { form: 12, label: '발효일', key: 'effectDt', type: 'date', style: { textAlign: 'center', minWidth: '60px' }, sendMaper: v => v.replace(/-/g, '') },
      { form: 13, label: '로그인\n실패 횟수', key: 'pwdErrCnt', hide: ['추가', '수정'], style: { textAlign: 'center', minWidth: '40px' } },
      { form: 14, label: '서비스 동의', key: 'svcAgreeNm', hide: ['추가', '수정'], style: { textAlign: 'center', minWidth: '40px' } },
      { form: 15, label: '마지막로그인', key: 'lastAccessDt', hide: ['추가', '수정'], type: 'datetime-local', style: { textAlign: 'center', minWidth: '60px' } },
      { form: 16, label: '조직', key: 'custNms', hide: ['추가', '수정'], style: { textAlign: 'center', minWidth: '60px' } },
    ],
    // checkActions: 체크박스 선택시 일괄처리 엑션 (비어있으면 비활성)
    actions: ['수정', '잠금', '잠금해제', '오류횟수 초기화', '비밀번호 초기화', '영구삭제', '아이디 변경'],
    filter: [{key:'statusCd', label:'상태', cd: 'MEMBER_STATUS'}],
    listParams: { statusCd:null, searchKeyword:'', effectDtFrom:'', effectDtTo:'', pwdErrOver: 'N' },
    detail: { effectDt: ['', ''], pwdErrOver: false },
  }),
  created() { this.getList(true) },
  mounted() { },// template 렌더링 후 실행 (this.$el 로 접근가능)
  beforeDestroy() { },
  computed: {},
  watch: { listParams: { deep: true, handler: 'getList' } },
  methods: {
    detailSearch({ form }) {
      setTimeout(() => document.activeElement.blur(), 500);
      if (form) this.detail.effectDt = form.effectDt;
      const check = this.detail.effectDt.join('') || this.detail.pwdErrCnt != 'N';
      if (!form && !check) return;
      else if (!form) this.detail.effectDt = ['', ''];
      else if (form && form.effectDt[0] && form.effectDt[1] && form.effectDt[0] > form.effectDt[1]) return this.$alert(this.$t('시작범위가 종료범위보다 큽니다.'));
      this.listParams.effectDtFrom = this.detail.effectDt[0];
      this.listParams.effectDtTo = this.detail.effectDt[1];
      this.listParams.pwdErrOver = this.detail.pwdErrOver === true ? 'Y' : 'N';
    },
    admIcon() { // 공통으로 사용되지는 않아 공통에서 페이지의 함수로 옮깁니다.
      return `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-person-fill-gear" viewBox="0 0 16 16">
                <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Zm9.886-3.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"/>
              </svg>`
    },
    async action({ action, item, form }) {
      this.sel = item;
      if (['view', '수정'].includes(action)) {
        const unmaskKey = await this.$unmask(action == 'view' ? 'USER_INFO' : 'USER_UPD');
        const selUser = await this.$api('adm/user/selectUser', { unmaskKey, masking: false, userId : this.sel.userId });
        for (const key in selUser.data) { 
          this.sel[key] = selUser.data[key];
        }
        this.userIdInputEdit = selUser.data.userIdText;
        
        return this.$bvModal.show(action);
      } else if (['잠금', '잠금해제', '오류횟수 초기화', '비밀번호 초기화'].includes(action)) {
        if (!(await this.$alert(this.$t('[$] 사용자를 $ 하시겠습니까?', [item.userNm, action]), { confirm: true, title: action }))) return;
        const res = await this.$api(`adm/user/${({ 잠금: 'lockUser', 잠금해제: 'unlockUser', '오류횟수 초기화': 'initPwdErrCnt', '비밀번호 초기화': 'initUserPwd' })[action]}`, { userId: item.userId });
        await this.$alert(res.msg);
        if (res.success) {
          this.refreshUser(res.data);
          return;
        }
      } else if (['영구삭제'].includes(action)) {
        const confirmBody = `
          <div>
            <div>${this.$t('[$] 사용자를 $ 하시겠습니까?', [this.sel.userNm, action])}</div>
            <div class="mt-5">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input type="checkbox" class="form-check-input me-4" id="personalInfoDelConfirm" />
                <label for="personalInfoDelConfirm" class="text-danger">${this.$t('계정 삭제 시, 모든 데이터가 영구 삭제되는 것에 동의합니다.')}</label>
              </div>
            </div>
          </div>
        `;
              
        form = { userId: this.sel.userId, memberId: this.sel.memberId };
        let confirmClose = false;
        let time = 0;
        while(!confirmClose && time++ < 5) {
          if (await this.$alert(confirmBody, { confirm: true, title: action, size: 'w-325' })) {
            form.personalInfoDelConfirm = document.getElementById('personalInfoDelConfirm').checked;
            const res = await this.$api(`adm/user/deleteUser`, form);
            await this.$alert(res.msg);
            if(res.success) {
              confirmClose = true;
              this.getList(true);
            }            
          } else {
            confirmClose = true;
          }
        }

        return;
      } else if (['아이디 변경'].includes(action)) {
        if(this.sel.masking) {
          this.$alert(this.$t('마스킹을 해제하고 수행해주세요.'));
          return;
        }
        
        const confirmBody = `
          <div>
            <div>${this.$t('사용자 아이디를 변경하시겠습니까?')}</div>
            <div class="mt-4 d-flex align-items-center">
              <span class="me-2 fw-bold fs-6">변경전 :</span><span>${this.sel.userIdText}</span>
            </div>
            <div class="mt-4 d-flex align-items-center">
              <span class="me-2 fw-bold fs-6">변경후 :</span><input type="text" id="newUserId" class="form-control w-200px" />
            </div>
            <div class="mt-5">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input type="checkbox" class="form-check-input me-4" id="userIdChgConfirm" />
                <label for="userIdChgConfirm" class="text-danger">${this.$t('변경 시 모든 데이터가 새 아이디로 업데이트됨을 이해하고, 아이디 변경에 동의합니다.')}</label>
              </div>
            </div>
          </div>
        `;

        form = { oldUserId: this.sel.userIdText };
        let confirmClose = false;
        let time = 0;
        while(!confirmClose && time++ < 5) {          
          if (await this.$alert(confirmBody, { confirm: true, title: action, size: 'w-350' })) {
            form.newUserId = document.getElementById('newUserId').value;
            form.userIdChgConfirm = document.getElementById('userIdChgConfirm').checked;
            const res = await this.$api(`adm/user/changeUserId`, form);
            await this.$alert(res.msg);
            if(res.success) {
              confirmClose = true;
              this.getList(true);
              return;
            }
          } else {
            confirmClose = true;
            return;
          }

          this.$nextTick(() => { if(form.newUserId) document.getElementById('newUserId').value = form.newUserId; });
        }
      }
    },
    async modalAddUser() {
      this.adminOnly = false;
      this.userIdInput = '';
      const formattedDate = new Date().toLocaleString('sv-SE', { hour12: false }).replace(',', '').slice(0, 10);
      this.$refs.addUser._data.form.effectDt = formattedDate;
    },
    async modalEditUser() {
      const { form, spec } = this.$refs.editUser;
      const cutEffectDt = this.sel.effectDt;
      for (const key in this.sel) if (spec.find(s => s.key == key)) {
        form[key] = this.sel[key];
        form.effectDt = cutEffectDt.slice(0,4) + "-" + cutEffectDt.slice(4,6) + "-" + cutEffectDt.slice(6,8);
        this.adminOnly = form.adminOnly == 'Y' ? true : false;
      }
    },
    async addAction({ form }) {
      form.userId = this.userIdInput;
      form.adminOnly = this.adminOnly ? 'Y' : 'N';
      const res = await this.$api(`adm/user/insertUser`, form);
      await this.$alert(res.msg);
      if (res.success) this.$bvModal.hide("추가"); this.getList(true); 
    },
    async editAction({ form, action }) {
      if (!(await this.$alert(this.$t('[$] 사용자를 $ 하시겠습니까?', [this.sel.userNm, action]), { confirm: true, title: action }))) return;
      form.adminOnly = this.adminOnly ? 'Y' : 'N';
      form.userId = this.sel.userId;
      const res = await this.$api(`adm/user/updateUser`, form);
      await this.$alert(res.msg);
      if (res.success) { this.$bvModal.hide("수정"); this.getList(true); }
    },         
    // 사용자추가 - 자동생성 버튼 클릭 시 아이디 생성
    // async autoUserId() {
    //   const res = await this.$api('adm/user/generateUserId', { searchKeyword: this.searchKeyword });
    //   this.userIdInput = res.data;
    // },
    /** 목록 데이터 수신 */
    async getList(reset) {
      if (reset != undefined) this.list = [];
      const {list, parameter:{total}} = await this.$api('adm/user/selectUserList', { ...this.listParams, firstIndex: this.list.length + 1 });
      this.total = total;
      this.list.push(...list);
      if(reset == true) {
        const updateOption = await this.$api('adm/user/selectRoleList', { searchKeyword : this.listParams.searchKeyword });
        this.columns.getCol('roleId').options = updateOption.list.map( item => ({text:item.roleNm, value:item.roleId}) );
      }
    },
    /** 데이블에서 페이징중 추가 데이터가 필요할때 이벤트 처리 */
    nextList() { if (this.total > this.list.length) this.getList(); },
    async refreshUser(user) {
      this.keepPage = true;
      this.$set(this.list, this.list.findIndex(item => item.userId === user.userId), user);
      this.$nextTick(()=> { this.keepPage = false; });
    },
  },
}
</script>